import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-template-body" }
const _hoisted_2 = { class: "template-list" }
const _hoisted_3 = {
  key: 0,
  class: "template-group"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "template-radio-label" }
const _hoisted_6 = {
  key: 0,
  class: "template-badge-new"
}
const _hoisted_7 = {
  key: 1,
  class: "template-group"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "template-radio-label" }
const _hoisted_10 = { class: "template-preview" }
const _hoisted_11 = {
  key: 0,
  class: "preview-sections"
}
const _hoisted_12 = { class: "preview-section-title" }
const _hoisted_13 = { class: "preview-section-skeleton" }
const _hoisted_14 = {
  key: 1,
  class: "preview-sections"
}
const _hoisted_15 = { class: "preview-section-skeleton" }
const _hoisted_16 = {
  key: 2,
  class: "preview-empty"
}
const _hoisted_17 = { class: "form-template-footer" }

import { ref, computed, watch } from "vue";

interface Template {
  id: number;
  description: string;
  name?: string;
  sections?: Record<string, string>;
}

const MAX_INITIAL_CUSTOM = 3;
const MAX_INITIAL_STANDARD = 3;

interface Props {
  templates: Template[];
  preSelectedTemplateId: number | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AIAssistantFormTemplateSelectionModal',
  props: {
    templates: {},
    preSelectedTemplateId: {}
  },
  emits: ["select", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const isOpen = ref(true);
const expanded = ref(false);
const standardExpanded = ref(false);
const confirming = ref(false);

const PINNED_STANDARD_IDS = [-4, -5];

const selectedId = ref<number | null>(props.preSelectedTemplateId ?? props.templates[0]?.id ?? null);

/** Templates padronizados (id < 0) */
const standardTemplates = computed(() => props.templates.filter((t) => t.id < 0));

/** Templates padronizados visíveis por padrão (primeiros 3) */
const displayedStandardTemplates = computed(() => {
  if (standardExpanded.value) return standardTemplates.value;
  return standardTemplates.value.slice(0, MAX_INITIAL_STANDARD);
});

/** Mostra "Ver mais" quando há mais de 3 templates padronizados */
const hasMoreStandard = computed(
  () => standardTemplates.value.length > MAX_INITIAL_STANDARD && !standardExpanded.value,
);

/** All custom templates (id >= 0) */
const allCustomTemplates = computed(() => props.templates.filter((t) => t.id >= 0));

/** Custom templates shown (first 5 or all if expanded) */
const customTemplates = computed(() => {
  if (expanded.value) return allCustomTemplates.value;
  return allCustomTemplates.value.slice(0, MAX_INITIAL_CUSTOM);
});

/** Show "Ver mais" when there are more than 5 custom templates */
const hasMore = computed(() => allCustomTemplates.value.length > MAX_INITIAL_CUSTOM && !expanded.value);

const selectedTemplate = computed(() => {
  if (!selectedId.value) return null;
  return props.templates.find((t) => t.id === selectedId.value) ?? null;
});

/** Parsed sections from template: { title, description } pairs */
const selectedTemplateSections = computed(() => {
  if (!selectedTemplate.value) return [];
  const sections = selectedTemplate.value.sections;
  if (sections && typeof sections === "object" && !Array.isArray(sections)) {
    return Object.entries(sections).map(([title, description]) => ({ title, description }));
  }
  return [];
});

watch(isOpen, (val) => {
  if (!val && !confirming.value) emit("close");
});

watch(
  () => props.preSelectedTemplateId,
  (newId) => {
    if (newId !== null) selectedId.value = newId;
  },
);

const onConfirm = () => {
  if (selectedId.value) {
    confirming.value = true;
    emit("select", selectedId.value);
  }
};

const onClose = () => {
  isOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_w_skeleton = _resolveComponent("w-skeleton")!
  const _component_w_text = _resolveComponent("w-text")!
  const _component_w_button = _resolveComponent("w-button")!
  const _component_w_modal = _resolveComponent("w-modal")!

  return (_openBlock(), _createBlock(_component_w_modal, {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((isOpen).value = $event)),
    size: "large",
    class: "form-template-selection-modal",
    title: "Selecionar modelo Anamnese e Evolução",
    "close-on-click-outside": false,
    style: {"z-index":"999999999"},
    onClose: onClose
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (__props.templates.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (standardTemplates.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "template-group-title spacing-bottom" }, "Criados pelo Noa", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedStandardTemplates.value, (template) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: template.id,
                          class: _normalizeClass(["template-radio-item", { selected: selectedId.value === template.id }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: template.id,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedId).value = $event)),
                            class: "template-radio-input"
                          }, null, 8, _hoisted_4), [
                            [_vModelRadio, selectedId.value]
                          ]),
                          _createElementVNode("span", _hoisted_5, [
                            _createTextVNode(_toDisplayString(template.description) + " ", 1),
                            (!PINNED_STANDARD_IDS.includes(template.id))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Novo"))
                              : _createCommentVNode("", true)
                          ])
                        ], 2))
                      }), 128)),
                      (hasMoreStandard.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "see-more-btn",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (standardExpanded.value = true))
                          }, " Ver mais "))
                        : _createCommentVNode("", true),
                      (standardExpanded.value && standardTemplates.value.length > MAX_INITIAL_STANDARD)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "see-more-btn",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (standardExpanded.value = false))
                          }, " Ver menos "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (customTemplates.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "template-group-title" }, "Criados por você", -1)),
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "template-group-subtitle spacing-bottom" }, "criados por você em seu estilo de documentação", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customTemplates.value, (template) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: template.id,
                          class: _normalizeClass(["template-radio-item", { selected: selectedId.value === template.id }])
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "radio",
                            value: template.id,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedId).value = $event)),
                            class: "template-radio-input"
                          }, null, 8, _hoisted_8), [
                            [_vModelRadio, selectedId.value]
                          ]),
                          _createElementVNode("span", _hoisted_9, _toDisplayString(template.description), 1)
                        ], 2))
                      }), 128)),
                      (hasMore.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "see-more-btn",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (expanded.value = true))
                          }, " Ver mais "))
                        : _createCommentVNode("", true),
                      (expanded.value && allCustomTemplates.value.length > MAX_INITIAL_CUSTOM)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "see-more-btn",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (expanded.value = false))
                          }, " Ver menos "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(3, (n) => {
                return _createElementVNode("div", {
                  key: n,
                  class: "template-radio-item skeleton-item"
                }, [
                  _createVNode(_component_w_skeleton, {
                    height: 18,
                    width: 18,
                    shape: "circle"
                  }),
                  _createVNode(_component_w_skeleton, {
                    height: 14,
                    shape: "pill",
                    width: "70%"
                  })
                ])
              }), 64))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "preview-header" }, [
            _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              width: "16",
              height: "16",
              class: "preview-eye-icon"
            }, [
              _createElementVNode("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }),
              _createElementVNode("circle", {
                cx: "12",
                cy: "12",
                r: "3"
              })
            ]),
            _createElementVNode("span", { class: "preview-title" }, "Pré-visualização")
          ], -1)),
          (selectedTemplateSections.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTemplateSections.value, (section, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "preview-section"
                  }, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(section.title), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_w_skeleton, {
                        height: 10,
                        shape: "pill",
                        width: "80%"
                      }),
                      _createVNode(_component_w_skeleton, {
                        height: 10,
                        shape: "pill",
                        width: "50%",
                        class: "skeleton-spacing"
                      })
                    ])
                  ]))
                }), 128))
              ]))
            : (selectedTemplate.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                    return _createElementVNode("div", {
                      key: n,
                      class: "preview-section"
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_w_skeleton, {
                          height: 12,
                          shape: "pill",
                          width: "40%"
                        }),
                        _createVNode(_component_w_skeleton, {
                          height: 10,
                          shape: "pill",
                          width: "80%",
                          class: "skeleton-spacing"
                        }),
                        _createVNode(_component_w_skeleton, {
                          height: 10,
                          shape: "pill",
                          width: "50%",
                          class: "skeleton-spacing"
                        })
                      ])
                    ])
                  }), 64))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(_component_w_text, {
                    type: "body",
                    "text-align": "center",
                    class: "preview-empty-text"
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode(" Selecione um template para visualizar ", -1)
                    ]))]),
                    _: 1
                  })
                ]))
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_w_button, {
          label: "Cancelar",
          variant: "secondary",
          onClick: onClose
        }),
        _createVNode(_component_w_button, {
          label: "Selecionar modelo",
          variant: "primary",
          disabled: !selectedId.value,
          onClick: onConfirm
        }, null, 8, ["disabled"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})